export default class ExperienceAvailability {
    constructor(experienceId = 0, guideId = 0, availableDate = new Date(), startTime = "09:00", minPeople = 1, maxPeople = 10, isAvailable = true) {
        this.experienceId = experienceId;
        this.guideId = guideId;
        this.availableDate = availableDate;
        this.startTime = startTime;
        this.minPeople = minPeople;
        this.maxPeople = maxPeople;
        this.isAvailable = isAvailable;
    }

    isValid() {
        return this.experienceId > 0 && 
               this.guideId > 0 && 
               this.availableDate && 
               this.startTime && 
               this.minPeople > 0 && 
               this.maxPeople > 0 && 
               this.minPeople <= this.maxPeople;
    }

    // Helper method to format date for API
    getFormattedDate() {
        if (this.availableDate instanceof Date) {
            return this.availableDate.toISOString().split('T')[0];
        }
        return this.availableDate;
    }

    // Helper method to format time for API
    getFormattedStartTime() {
        return this.startTime + ":00";
    }

    // Method to create a copy of the object
    clone() {
        return new ExperienceAvailability(
            this.experienceId,
            this.guideId,
            this.availableDate,
            this.startTime,
            this.minPeople,
            this.maxPeople,
            this.isAvailable
        );
    }
}

